import { useState, useEffect } from "react";
import defaultIcon from "@amo/core/assets/images/icons/clients/avis-1.png";
import { Avis } from "@amo/core/components/containers";
import { getAvisClients } from "@amo/core/utils/requestsApi";

const BlocAvis = () => {
    const [avis, setAvis] = useState([]);

    useEffect(() => {
        let cancelled = false;

        getAvisClients()
            .then((data) => {
                if (!cancelled && data && data.length > 0) {
                    setAvis(data.map((item) => ({
                        id: item.id,
                        name: item.name,
                        content: item.content,
                        date: item.date,
                        icon: item.photo || defaultIcon,
                    })));
                }
            })
            .catch(() => {});

        return () => { cancelled = true; };
    }, []);

    if (avis.length === 0) return null;

    return (
        <div className={'container mt-5'}>
            <div className={'row'}>
                {avis.map((item, index) => (
                    <Avis
                        key={item.id}
                        name={item.name}
                        icon={item.icon}
                        content={item.content}
                        date={item.date}
                        isLast={index === avis.length - 1}
                    />
                ))}
            </div>
        </div>
    );
};

export default BlocAvis;
